import React from 'react';
import {
  Table,
  TableHeader,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '../../../components/ui/table';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../components/ui/tooltip';
import { CopyButton } from '../../../components/ui/copy-button';
import { SeriesData } from '@/types/types';

interface SeriesTableProps {
  series: SeriesData[];
}

export const SeriesTable: React.FC<SeriesTableProps> = ({ series }) => {
  return (
    <div className="p-4">
      <div className="mb-2 font-semibold text-foreground">Series in this Study:</div>
      <div className="relative max-h-64 overflow-y-auto border-t-0">
        <Table className="rounded-[10px] border border-border border-separate border-spacing-0 bg-background">
          <TableHeader className="sticky top-0 z-[1] bg-muted">
            <TableRow>
              <TableHead className="border border-border">
                Series Number
              </TableHead>
              <TableHead className="border border-border">
                Series Instance UID
              </TableHead>
              <TableHead className="border border-border">
                Series Description
              </TableHead>
              <TableHead className="border border-border">Modality</TableHead>
              <TableHead className="border border-border">
                Number of Instances
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {series.map((series) => (
              <TableRow key={series.SeriesInstanceUID}>
                <TableCell className="ml-2 border border-border text-foreground">
                  {series.SeriesNumber || '0'}
                </TableCell>
                <TableCell className="border border-border text-foreground">
                  <div className="flex items-center gap-2">
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <span className="cursor-pointer max-w-40 overflow-hidden truncate block">
                            {series.SeriesInstanceUID}
                          </span>
                        </TooltipTrigger>
                        <TooltipContent>
                          <span>{series.SeriesInstanceUID}</span>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                    <CopyButton 
                      value={series.SeriesInstanceUID}
                      label="Copy Series Instance UID"
                    />
                  </div>
                </TableCell>
                <TableCell className="ml-2 border border-border text-foreground">
                  {series.SeriesDescription || 'N/A'}
                </TableCell>
                <TableCell className="ml-2 border border-border text-foreground">
                  {series.Modality || 'N/A'}
                </TableCell>
                <TableCell className="ml-2 border border-border text-foreground">
                  {series.InstanceCount || '0'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
